import {
  configNewRelic,
  INewRelicConfig,
  logger,
} from "@origin-digital/reporting-client";
import { IErrorResponse } from "../interfaces/index";
import { LOG_TAG } from "../logTag";

/**
 * This class is just a wrapper to initialize the New Relic logger using the
 * reporting-client.
 */

interface LoggerPayLoad {
  errorMessage: string;
  payload: any;
}
export class Logger {
  /**
   * Bootstraps the New Relic config and initialises a New Relic logging instance.
   * @param config{INewRelicConfig} - Object containing required New Relic params
   */
  public bootstrap(config: INewRelicConfig) {
    if (config && Object.keys(config).length !== 0) {
      configNewRelic({
        appName: config.appName,
        endpoint: config.endpoint,
        sourceEnv: config.sourceEnv,
        apiKey: config.apiKey,
        sendOnErrors: true,
        logLevel: config.logLevel,
        consoleLogLevel: config.consoleLogLevel,
      });
    } else {
      console.log("Reporting client configurations are empty");
    }
  }

  public error(args: IErrorResponse) {
    const loggerPayload = this.createLoggerPayLoad(args);
    logger.log("error", loggerPayload.errorMessage, loggerPayload.payload);
  }

  public debug(args: IErrorResponse) {
    const loggerPayload = this.createLoggerPayLoad(args);
    logger.debug(loggerPayload.errorMessage, loggerPayload.payload);
  }

  createLoggerPayLoad = (args: IErrorResponse): LoggerPayLoad => {
    const { timestamp }: any = args;
    // prettier-ignore
    const isoTimestamp = timestamp ? new Date(timestamp).toISOString() : new Date().toISOString();
    const errorMessage = `${LOG_TAG} ${args.methodName} - ${args.displayMessage.errorCode} - ${args.displayMessage.body}`;
    const payload: any = { ...args.data, timestamp: isoTimestamp };

    return {
      errorMessage,
      payload,
    };
  };
}
